export default __webpack_public_path__ + "static/media/web.07359578.svg";